export default {
  user(state) {
    return state.userData
  },

}